import React, { Component } from 'react';
import { partnerApi, partnerArticles } from '../../../../API/FetchCall';
import swal from 'sweetalert';
const $ = require('jquery')
class YourArticles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }
        this.getpageData();
    }

    componentDidMount() {
        var THIS = this;

    }
    getpageData = async () => {
        const { user_type, login_id } = this.state.user_data;
        let insdata = JSON.stringify({
            login_id: login_id
        });
        await partnerArticles(insdata).then((response) => {
            if (response.status === 1) {
                this.datatabledata(response.data);
            }
        });
    }
    datatabledata(data) {
        console.log('data', data)
        this.setState({
            dataSet: data
        })
        this.el = $(this.el)
        this.el.DataTable(
            {
                data: this.state.dataSet,
                columns: [
                    { data: 'title' },
                    { data: 'updated_date' },
                    { data: 'status' },
                    { data: 'action' },
                ]

            }
        )
    }

    render() {
        return (
            <React.Fragment>
                <div class="box-shadow-custom">
                    {/* <h1>Branches</h1> */}
                    <div className='col-md-12'>
                        
                        <div className='row'>
                            <div className="table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                <table className="table dataTable" ref={el => this.el = el}>
                                    <thead>
                                        <tr role="row">
                                            <th className="tabledata">Title</th>
                                            <th className="tabledata">Date</th>
                                            <th className="tabledata">Status</th>
                                            <th className="tabledata">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default YourArticles;





// WEBPACK FOOTER //
// ./src/components/bewise/partners/articles/yourarticles.jsx